import {OrbitControlConstraint} from './OrbitControlConstraint';

export class GroundConstraint extends OrbitControlConstraint {

  private minY: number;

  constructor(minY: number) {
    super();
    this.minY = minY;
  }

  check(camera, newPosition): boolean {
    return newPosition.y >= this.minY;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/orbitControlConstraint/GroundConstraint.ts